<template>
    <form class="selector" @submit.stop="updateValue($event, value)">
        <div class="form-group">
            <label for="searchString">Search</label>

            <div class="form-group form-group-selectr">
                <input
                    type="search"
                    inputmode="search"
                    id="searchString"
                    class="form-control"
                    name="searchString"
                    :placeholder="placeholder"
                    autocomplete="search"
                    v-model="value"
                    @input.stop="updateValue($event)"
                >
            </div>
        </div>
    </form>
</template>

<script>
    import VisibleSelectorWidget from './VisibleSelectorWidget';

    export default {
        extends: VisibleSelectorWidget,
        props: [
            'placeholder'
        ],
        methods: {
            broadcast(value) {
                window.events.emit('updateSearchString', value);
            }
        }
    }
</script>
